




















import Vue from "vue";
export default Vue.extend({
   methods: {
    goto: function(route: string): void {
      this.$router.push({ name: route }).catch(() => {});
    }
  }
});
